var _path, _path2, _path3, _circle, _circle2, _polygon, _path4, _polygon2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle3, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 865.67004,
    height: 711.47194,
    viewBox: "0 0 865.67004 711.47194",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "be762e0f-b118-45b0-834c-015dca31fdfd-397",
    "data-name": "Path 339",
    d: "M611.15112,263.156h-3.9V156.179a61.915,61.915,0,0,0-61.915-61.915h-226.65a61.915,61.915,0,0,0-61.916,61.914V743.062a61.915,61.915,0,0,0,61.915,61.915h226.648a61.915,61.915,0,0,0,61.915-61.915V339.304h3.9Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bd19cda7-6ee4-487f-8299-09f5b9520cce-398",
    "data-name": "Path 340",
    d: "M594.62415,152.032V747.207a46.959,46.959,0,0,1-46.942,46.952h-231.3a46.966,46.966,0,0,1-46.973-46.952V152.032a46.965,46.965,0,0,1,46.971-46.951h28.058a22.329,22.329,0,0,0,20.656,30.74h131.868a22.329,22.329,0,0,0,20.656-30.74h30.055a46.959,46.959,0,0,1,46.951,46.942Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M540.92969,666.47461H327.31787a29.01035,29.01035,0,0,1-28.97754-28.97754V336.99268c0-72.96192,59.3584-132.3208,132.32031-132.3208H540.93018a29.00984,29.00984,0,0,1,28.97705,28.97705V637.49707A29.01,29.01,0,0,1,540.92969,666.47461Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "be454a6a-b415-4179-b5e8-57164f143cba",
    "data-name": "Ellipse 7",
    cx: 147.3572,
    cy: 629.16794,
    r: 15.37866,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "be5a0c73-855d-427d-a69e-6f1eaa4c04a0",
    "data-name": "Ellipse 7",
    cx: 386.86341,
    cy: 629.16794,
    r: 15.37866,
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "388.948 571.619 379.414 582.009 334.805 550.181 348.876 534.847 388.948 571.619",
    fill: "#ffb6b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M568.61505,672.47461,537.87532,705.9738l-.42372-.38879a17.69746,17.69746,0,0,1-1.07478-25.00335l.00076-.00083.97238-10.379L552.469,663.045l2.6834-2.92427Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.181 687.559 381.081 687.558 374.373 633.171 395.184 633.172 395.181 687.559",
    fill: "#ffb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M565.94229,795.49106l-45.46567-.00169v-.57507a17.69746,17.69746,0,0,1,17.69651-17.69622h.00112l8.3049-6.30054,15.4951,6.3015,3.96888.00016Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "a30b4662-e5c2-40ab-b3a2-3f3e92442cbc-399",
    "data-name": "Path 17",
    d: "M494.25411,507.266s-86.138,83.167-31.683,108.91h16.831s5.058-17.96928,16.63727-33.12264c1.59018-2.081,7.54741-1.65826,9.20179-3.68636,10.10141-12.38329,21.05261-23.01828,28.61594-22.596l4.95,57.425-2.44219,16.83068a88.19336,88.19336,0,0,0,1.19448,31.8341v0l-1.72229,67.17524,30.20227.01737s1.21985-15.74366,2.24025-35.43474c.27336-5.2751,2.54231-8.95037,2.75975-14.56526.5213-13.461-1.20641-29.12982-1.53928-40.11539l22.772-120.791Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "bce5c948-7db7-43f8-8cd2-61a9f17c0c07-400",
    "data-name": "Path 22",
    d: "M534.03937,331.05331,519.9941,349.842l-33.663,19.8,19.8,51.484.751,38.30649-1.84277,4.62082,2.08174,7.56768s-.96062,8.85672-6.08174,15.43232c-8.95362,11.49658-22.62583,23.99213-8.76926,27.14169,21.782,4.951,99.009,15.841,102.969,6.931,1.36981-3.08208,1.19966-16.11578.391-31.84754-.15122-2.94186-3.40079-6.142-3.59077-9.22515-.14254-2.31334,2.7817-4.48913,2.62314-6.83525-1.7669-26.14462-4.3734-53.081-4.3734-53.081l7.75026-72.0837-31-8-3.48025-8.8723Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#d63030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "aa56653d-a1eb-49b2-bba0-f0dc0c583c83-401",
    "data-name": "Path 18",
    d: "M458.43521,611.2356l4.60416,5.81771s42.34451,29.62482,43.79856,32.39338l6.69207,6.33242,16.19225-17.30872-8.4206-10.55436a66.10234,66.10234,0,0,0-25.35712-19.41327h0l-12.90514-11.44945Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M485.34141,528.08817l7.71109-74.63911,2.0353-30.719-21.58313-3.90266s-3.232,21.11786-6.05941,33.51076c-2.79018,12.22915,3.717,74.11131,3.88946,75.74334a10.50079,10.50079,0,1,0,14.00669.00667Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#ffb9b9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M457.45534,465.98817l37.2588,9.45768-.2588-10.45768,2.82782-3,5.65-29.59722,8.1062-17.33764L508.93221,355.764l-20.58858,10.91954-.02512.01933a55.66255,55.66255,0,0,0-8.928,13.21991c-7.76154,15.77858-15.21745,50.53309-19.12034,70.71918a2.203,2.203,0,0,1-.74252,1.07,11.41536,11.41536,0,0,0-2.07235,14.27622Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#d63030"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M678.71622,485.04417s-45.35878-47.82044-45.78176-48.72177c-3.16847-24.06114-12.28147-34.67474-13.6476-33.5225L595.766,410.94839s6.99625,22.15475,11.73316,35.31426c4.5263,12.57444,56.69257,43.288,57.56313,44.80437a11.188,11.188,0,1,0,13.654-6.02285Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#ffb9b9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M576.77281,349.69891s23.08916-11.31585,32.04437,10.909c4.90935,12.547,17.46581,42.998,23.72314,61.743a1.40067,1.40067,0,0,0,.17043.33618,15.241,15.241,0,0,1,2.59638,8.40918,2.862,2.862,0,0,0,.06763.64912s-25.37273,4.94306-32.91942,18.2428l-2.99331-3.24832-.53212-2.27586-21.89054-58.41068Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#d63030"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M953.83625,440.40682H683.514a9.09549,9.09549,0,0,1-9.085-9.085V391.731a9.09549,9.09549,0,0,1,9.085-9.085H953.83625a9.09549,9.09549,0,0,1,9.085,9.085v39.59082A9.09549,9.09549,0,0,1,953.83625,440.40682Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M927.57111,434.27889H689.64337a9.09549,9.09549,0,0,1-9.085-9.085V397.86385a9.0955,9.0955,0,0,1,9.085-9.085H947.70832a9.0955,9.0955,0,0,1,9.085,9.085v7.19288A29.2551,29.2551,0,0,1,927.57111,434.27889Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M845.49982,408.71005H736.85089a2.343,2.343,0,1,1,0-4.686H845.49982a2.343,2.343,0,0,1,0,4.686Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#d63030"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M900.49982,418.29305H736.85089a2.343,2.343,0,1,1,0-4.686H900.49982a2.343,2.343,0,0,1,0,4.686Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M953.83625,524.40682H683.514a9.09549,9.09549,0,0,1-9.085-9.085V475.731a9.09549,9.09549,0,0,1,9.085-9.085H953.83625a9.09549,9.09549,0,0,1,9.085,9.085v39.59082A9.09549,9.09549,0,0,1,953.83625,524.40682Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M927.57111,518.27889H689.64337a9.09549,9.09549,0,0,1-9.085-9.085V481.86385a9.0955,9.0955,0,0,1,9.085-9.085H947.70832a9.0955,9.0955,0,0,1,9.085,9.085v7.19288A29.2551,29.2551,0,0,1,927.57111,518.27889Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M845.49982,492.71005H736.85089a2.343,2.343,0,1,1,0-4.686H845.49982a2.343,2.343,0,0,1,0,4.686Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#d63030"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M900.49982,502.29305H736.85089a2.343,2.343,0,1,1,0-4.686H900.49982a2.343,2.343,0,0,1,0,4.686Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M953.83625,608.40682H683.514a9.09549,9.09549,0,0,1-9.085-9.085V559.731a9.09549,9.09549,0,0,1,9.085-9.085H953.83625a9.09549,9.09549,0,0,1,9.085,9.085v39.59082A9.09549,9.09549,0,0,1,953.83625,608.40682Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M927.57111,602.27889H689.64337a9.09549,9.09549,0,0,1-9.085-9.085V565.86385a9.0955,9.0955,0,0,1,9.085-9.085H947.70832a9.0955,9.0955,0,0,1,9.085,9.085v7.19288A29.2551,29.2551,0,0,1,927.57111,602.27889Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M845.49982,576.71005H736.85089a2.343,2.343,0,1,1,0-4.686H845.49982a2.343,2.343,0,0,1,0,4.686Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#d63030"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M900.49982,586.29305H736.85089a2.343,2.343,0,1,1,0-4.686H900.49982a2.343,2.343,0,0,1,0,4.686Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "f8b50a69-a369-42b8-943f-f14ba4f1f80f",
    "data-name": "Ellipse 5",
    cx: 381.67412,
    cy: 202.48596,
    r: 28.272,
    fill: "#ffb9b9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M528.05143,314.93262a3.0924,3.0924,0,0,1-.99736-.16085,6.53654,6.53654,0,0,1-3.014-2.679c-4.86764-7.00083-7.218-16.33485-6.98492-27.74314.09849-4.82636.64469-10.99714,4.02469-15.916,2.84239-4.13608,8.59213-7.41845,13.95049-5.77081a5.79219,5.79219,0,0,1,2.8897-5.34718c2.02955-1.24293,4.47283-1.47173,6.628-1.6743,5.44223-.51008,11.0681-1.03735,16.57871.00688,6.179,1.172,11.2311,4.35671,13.861,8.7375l.05376.13762.53459,2.596a2.46521,2.46521,0,0,0,3.28237,1.81063,2.23672,2.23672,0,0,1,3.00152,2.41447l-.14924,1.03262,1.55431-.29074a2.23775,2.23775,0,0,1,2.50952,2.97487l-.43911,1.18745a2.3539,2.3539,0,0,1,1.71128.7535,2.16367,2.16367,0,0,1,.29332,2.54908,20.27084,20.27084,0,0,1-7.1604,7.20426,16.923,16.923,0,0,1-5.23278,2.05793,100.50121,100.50121,0,0,1-36.46,1.09628,20.55532,20.55532,0,0,1,.815,7.38016c-.38793,3.11249-2.21534,5.68092-4.65561,6.54323a11.24288,11.24288,0,0,1-1.7014.4103,9.97584,9.97584,0,0,0-1.62441.39481,4.75374,4.75374,0,0,0-1.39174,8.12464l1.20337-1.25411-.39137,1.5943a2.2875,2.2875,0,0,1-1.16638,1.45238A3.20545,3.20545,0,0,1,528.05143,314.93262Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M921.34506,741.8203l1.14386-25.71947a83.066,83.066,0,0,1,38.74474-9.80779c-18.60844,15.21377-16.28294,44.5407-28.899,64.99962a49.96435,49.96435,0,0,1-36.63939,23.08922l-15.5722,9.53437a83.72448,83.72448,0,0,1,17.647-67.84511A80.87282,80.87282,0,0,1,912.633,722.261C916.36256,732.09516,921.34506,741.8203,921.34506,741.8203Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#f2f2f2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.835,804.546a1.18647,1.18647,0,0,1-1.19006,1.19H168.355a1.19,1.19,0,0,1,0-2.38h863.29A1.18651,1.18651,0,0,1,1032.835,804.546Z",
    transform: "translate(-167.16498 -94.26403)",
    fill: "#ccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.6927c723889555b2ebac6519d5b434a9.svg";
export { ForwardRef as ReactComponent };